import React, { useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "state/hooks.ts";
import { 
  getPaymentMethodsState, 
  fetchPaymentMethods 
} from "state/slices/user-payment-methods-slice.ts";
import { 
  getDepositFundsModalState, 
  setSelectedPaymentMethod 
} from "state/slices/deposit-funds-modal-v2-slice.ts";
import BlockyBoldText from "components/custom-texts/blocky-bold-text.tsx";
import BlockyLightText from "components/custom-texts/blocky-light-text.tsx";
import PaymentMethodItem from "./payment-method-item.tsx";
import AddPaymentMethodButton from "./add-payment-method-button.tsx";

const DepositFundsModalCardPaymentBlock = () => {
  const dispatch = useAppDispatch();
  const paymentMethodsState = useAppSelector(getPaymentMethodsState);
  const modalState = useAppSelector(getDepositFundsModalState);
  
  useEffect(() => {
    if (paymentMethodsState.fetchPaymentMethodsStatus === "idle") {
      dispatch(fetchPaymentMethods());
    }
  }, [dispatch, paymentMethodsState.fetchPaymentMethodsStatus]);

  // Get the selected card ID from the modal state
  const selectedCardId = modalState.selectedPaymentMethod?.type === 'CARD' 
    ? modalState.selectedPaymentMethod.inovioUserPaymentMethodId 
    : undefined;

  const handleCardSelect = (cardId: string | 'NEW') => {
    dispatch(setSelectedPaymentMethod({ 
      type: 'CARD', 
      inovioUserPaymentMethodId: cardId 
    }));
  };

  if (paymentMethodsState.fetchPaymentMethodsStatus === "loading") {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "120px" }}>
        <Spinner animation="border" variant="light" size="sm" />
      </div>
    );
  }

  return (
    <div>
      {paymentMethodsState.items.map((method) => {
        const isSelected = selectedCardId === method.id || (method.is_default && !selectedCardId && selectedCardId !== 'NEW');
        
        return (
          <PaymentMethodItem
            key={method.id}
            id={method.id}
            isSelected={isSelected}
            onClick={(id) => handleCardSelect(id)}
            radioName="cardMethod"
          >
            <div style={{ 
              display: "flex", 
              justifyContent: "space-between", 
              alignItems: "center",
              width: "100%",
              padding: "4px 0"
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <BlockyBoldText style={{ 
                  color: "white", 
                  fontSize: "16px", 
                  fontWeight: "600"
                }}>
                  {method.card_brand}
                </BlockyBoldText>
                <BlockyLightText style={{ 
                  color: "rgba(255, 255, 255, 0.9)", 
                  fontSize: "16px", 
                  fontWeight: "500"
                }}>
                  •••• {method.last4}
                </BlockyLightText>
                <BlockyLightText style={{ 
                  color: "rgba(255, 255, 255, 0.8)", 
                  fontSize: "14px", 
                  fontWeight: "400"
                }}>
                  Exp: {method.expiry_month.toString().padStart(2, '0')}/{method.expiry_year.toString().slice(-2)}
                </BlockyLightText>
              </div>
              <div style={{ flex: "0 0 auto" }}>
                {method.is_default && (
                  <div style={{ 
                    color: "#ffc107", 
                    fontSize: "12px",
                    fontWeight: "700",
                    letterSpacing: "0.5px"
                  }}>
                    DEFAULT
                  </div>
                )}
              </div>
            </div>
          </PaymentMethodItem>
        );
      })}
      
      {/* Add New Card Button */}
      <AddPaymentMethodButton
        text="New Card"
        onClick={() => handleCardSelect('NEW')}
        isSelected={selectedCardId === 'NEW'}
      />
    </div>
  );
};

export default DepositFundsModalCardPaymentBlock; 